import { useFeatureFlagsContext } from '@fourthwall/components';
export const useDashboardFeatureFlags = () => {
    const { featureFlags } = useFeatureFlagsContext();
    return { dashboardFeatureFlags: featureFlags };
};
